import { useQuery, UseQueryResult } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { User as UserV3 } from "@/types/models/User/v3/User.interface";
import { UserClassroom } from "@/classrooms/queries";

interface ParamsToRetrieveUserClassrooms {
  userUniqueId: UserV3["unique_id"] | undefined;
  enabled?: boolean;
}

type QueryResult = { count: number; results: UserClassroom[] };

const useGetUserClassrooms = ({
  userUniqueId,
  enabled = false,
}: ParamsToRetrieveUserClassrooms): UseQueryResult<QueryResult, Error> => {
  return useQuery({
    enabled,
    queryKey: [ApiCatalog.classroomsThroughUser.key, userUniqueId],
    queryFn: async () => {
      const results = await api().get(
        ApiCatalog.classroomsThroughUser.endpoint,
        {
          urlReplacers: [{ id: userUniqueId }],
        },
      );

      return results;
    },
  });
};

export default useGetUserClassrooms;
